import { useState, useEffect } from "react";
// components
import Input from "../../../../../components/fields/input";
import Button from "../../../../../components/buttons/button";
import {
  useCreateannouncementMutation,
  useUpdateannouncementMutation,
} from "../../../../../store/Reducer/annocements";
import { useCreateFileMutation } from "../../../../../store/Reducer/file";
import moment from "moment";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

const AnnouncementBannersFields = ({
  formData,
  handleChange,
  errorMessage,
}) => {
  return (
    <>
      <Input
        label="Announcement Title"
        type="text"
        name="title"
        className="w-full"
        placeholder="Announcement Title"
        value={formData.title}
        onChange={handleChange}
        required
      />

      <Input
        label="Banner Text"
        type="text"
        name="bannerText"
        className="w-full"
        placeholder="Banner Text"
        value={formData.bannerText}
        onChange={handleChange}
        required
      />

      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        <div>
          <label
            htmlFor="displayFrom"
            className="mb-1 block text-sm font-normal text-gray-700"
          >
            Display From
          </label>
          <input
            type="date"
            name="displayFrom"
            value={formData.displayFrom}
            onChange={handleChange}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-3 p-2.5"
            required
          />
        </div>
        <div>
          <label
            htmlFor="displayUntil"
            className="mb-1 block text-sm font-normal text-gray-700"
          >
            Display Until
          </label>
          <input
            type="date"
            name="displayUntil"
            value={formData.displayUntil}
            onChange={handleChange}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-3 p-2.5"
            required
          />
          {errorMessage && (
            <p className="mt-2 text-sm text-red-600">{errorMessage}</p>
          )}
        </div>
      </div>

      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        <div>
          <label
            htmlFor="textColor"
            className="mb-1 block text-sm font-normal text-gray-700"
          >
            Text Color
          </label>
          <div className="flex items-center space-x-2">
            <input
              type="color"
              name="textColor"
              id="textColor"
              value={formData.textColor}
              onChange={handleChange}
              className="h-8 w-8 cursor-pointer"
              required
            />
            <input
              type="text"
              name="textColor"
              value={formData.textColor}
              onChange={handleChange}
              readOnly
              className="py-2 block w-full border-gray-300 focus:border-blue-500 focus:ring-blue-500 sm:text-sm focus:outline-none"
              required
            />
          </div>
        </div>
        <div>
          <label
            htmlFor="backgroundColor"
            className="mb-1 block text-sm font-normal text-gray-700"
          >
            Background Color
          </label>
          <div className="flex items-center space-x-2">
            <input
              type="color"
              name="backgroundColor"
              id="backgroundColor"
              value={formData.backgroundColor}
              onChange={handleChange}
              className="h-8 w-8 cursor-pointer"
              required
            />
            <input
              type="text"
              name="backgroundColor"
              value={formData.backgroundColor}
              onChange={handleChange}
              readOnly
              className="py-2 block w-full border-gray-300 focus:border-blue-500 focus:ring-blue-500 sm:text-sm focus:outline-none"
              required
            />
          </div>
        </div>
      </div>
    </>
  );
};

// The picture already saved (editing), or the one just chosen.
const CurrentPicture = ({ file }) => {
  const src = file instanceof File ? URL.createObjectURL(file) : file?.url;
  if (!src) return null;
  return <img src={src} alt="Announcement" className="mt-2 h-24 rounded-lg object-cover" />;
};

const AnnouncementSpecialSectionFields = ({ formData, handleChange }) => {
  return (
    <>
      <Input
        label="Announcement Title"
        type="text"
        name="title"
        className="w-full"
        placeholder="Announcement Title"
        value={formData.title}
        onChange={handleChange}
      />

      <Input
        label="Text"
        type="text"
        name="text"
        className="w-full"
        placeholder="Text"
        value={formData.text}
        onChange={handleChange}
      />

      {/* Upload Image */}
      <div className="w-full">
        <label htmlFor="image" className="sr-only">
          Choose file
        </label>
        <input
          type="file"
          name="file"
          id="image"
          accept="image/*"
          onChange={handleChange}
          className="block w-full border border-gray-300 shadow-sm rounded-lg text-sm focus:z-10 focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 file:bg-gray-50 file:border-0 file:me-4 file:py-3 file:px-4"
        />
        <CurrentPicture file={formData.file} />
      </div>

      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        <div>
          <label
            htmlFor="displayFrom"
            className="mb-1 block text-sm font-normal text-gray-700"
          >
            Display From
          </label>
          <input
            type="date"
            name="displayFrom"
            value={formData.displayFrom}
            onChange={handleChange}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-3 p-2.5"
          />
        </div>
        <div>
          <label
            htmlFor="displayUntil"
            className="mb-1 block text-sm font-normal text-gray-700"
          >
            Display Until
          </label>
          <input
            type="date"
            name="displayUntil"
            value={formData.displayUntil}
            onChange={handleChange}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-3 p-2.5"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        <div>
          <label
            htmlFor="textColor"
            className="mb-1 block text-sm font-normal text-gray-700"
          >
            Text Color
          </label>
          <div className="flex items-center space-x-2">
            <input
              type="color"
              name="textColor"
              id="textColor"
              value={formData.textColor}
              onChange={handleChange}
              className="h-8 w-8 cursor-pointer"
            />
            <input
              type="text"
              name="textColor"
              value={formData.textColor}
              onChange={handleChange}
              readOnly
              className="py-2 block w-full border-gray-300 focus:border-blue-500 focus:ring-blue-500 sm:text-sm focus:outline-none"
            />
          </div>
        </div>
        <div>
          <label
            htmlFor="backgroundColor"
            className="mb-1 block text-sm font-normal text-gray-700"
          >
            Background Color
          </label>
          <div className="flex items-center space-x-2">
            <input
              type="color"
              name="backgroundColor"
              id="backgroundColor"
              value={formData.backgroundColor}
              onChange={handleChange}
              className="h-8 w-8 cursor-pointer"
            />
            <input
              type="text"
              name="backgroundColor"
              value={formData.backgroundColor}
              onChange={handleChange}
              readOnly
              className="py-2 block w-full border-gray-300 focus:border-blue-500 focus:ring-blue-500 sm:text-sm focus:outline-none"
            />
          </div>
        </div>
      </div>
    </>
  );
};

const AnnouncementBothFields = ({ formData, handleChange }) => {
  return (
    <>
      <Input
        label="Announcement Title"
        type="text"
        name="title"
        className="w-full"
        placeholder="Announcement Title"
        value={formData.title}
        onChange={handleChange}
      />
      <Input
        label="Banner Text"
        type="text"
        name="bannerText"
        className="w-full"
        placeholder="Banner Text"
        value={formData.bannerText}
        onChange={handleChange}
      />

      <Input
        label="Text"
        type="text"
        name="text"
        className="w-full"
        placeholder="Text"
        value={formData.text}
        onChange={handleChange}
      />

      {/* Upload Image */}
      <div className="w-full">
        <label htmlFor="image" className="sr-only">
          Choose file
        </label>
        <input
          type="file"
          name="file"
          id="image"
          accept="image/*"
          onChange={handleChange}
          className="block w-full border border-gray-300 shadow-sm rounded-lg text-sm focus:z-10 focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 file:bg-gray-50 file:border-0 file:me-4 file:py-3 file:px-4"
        />
        <CurrentPicture file={formData.file} />
      </div>

      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        <div>
          <label
            htmlFor="displayFrom"
            className="mb-1 block text-sm font-normal text-gray-700"
          >
            Display From
          </label>
          <input
            type="date"
            name="displayFrom"
            value={formData.displayFrom}
            onChange={handleChange}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-3 p-2.5"
          />
        </div>
        <div>
          <label
            htmlFor="displayUntil"
            className="mb-1 block text-sm font-normal text-gray-700"
          >
            Display Until
          </label>
          <input
            type="date"
            name="displayUntil"
            value={formData.displayUntil}
            onChange={handleChange}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-3 p-2.5"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        <div>
          <label
            htmlFor="textColor"
            className="mb-1 block text-sm font-normal text-gray-700"
          >
            Text Color
          </label>
          <div className="flex items-center space-x-2">
            <input
              type="color"
              name="textColor"
              id="textColor"
              value={formData.textColor}
              onChange={handleChange}
              className="h-8 w-8 cursor-pointer"
            />
            <input
              type="text"
              name="textColor"
              value={formData.textColor}
              onChange={handleChange}
              readOnly
              className="py-2 block w-full border-gray-300 focus:border-blue-500 focus:ring-blue-500 sm:text-sm focus:outline-none"
            />
          </div>
        </div>
        <div>
          <label
            htmlFor="backgroundColor"
            className="mb-1 block text-sm font-normal text-gray-700"
          >
            Background Color
          </label>
          <div className="flex items-center space-x-2">
            <input
              type="color"
              name="backgroundColor"
              id="backgroundColor"
              value={formData.backgroundColor}
              onChange={handleChange}
              className="h-8 w-8 cursor-pointer"
            />
            <input
              type="text"
              name="backgroundColor"
              value={formData.backgroundColor}
              onChange={handleChange}
              readOnly
              className="py-2 block w-full border-gray-300 focus:border-blue-500 focus:ring-blue-500 sm:text-sm focus:outline-none"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default function CreateAnnouncementModal({
  isOpen,
  closeModal,
  isEdit,
  rowData,
}) {
  const [selectedTypes, setSelectedTypes] = useState({
    banner: true,
    specialSection: false,
  });

  const {t} = useTranslation()

  const [formData, setFormData] = useState({
    type: selectedTypes,
    title: "",
    text: "",
    bannerText: "",
    displayFrom: "",
    displayUntil: "",
    textColor: "#000000",
    backgroundColor: "#ffffff",
    file: null,
    isPublished: false,
  });
  const [errorMessage, setErrorMessage] = useState("");
  // Which save button was pressed: "draft" or "publish".
  const [saving, setSaving] = useState(null);

  const [createAnnouncement] = useCreateannouncementMutation();
  const [updateannouncement] = useUpdateannouncementMutation();
  const [createFile] = useCreateFileMutation();

  const resetForm = () => {
    setSelectedTypes({
      banner: true,
      specialSection: false,
    });
    setFormData({
      type: selectedTypes,
      title: "",
      text: "",
      bannerText: "",
      displayFrom: "",
      displayUntil: "",
      textColor: "#000000",
      backgroundColor: "#ffffff",
      file: null,
      isPublished: false,
    });
    setErrorMessage("");
  };

  // Add effect to reset form when modal closes
  useEffect(() => {
    if (!isOpen) {
      resetForm();
    }
  }, [isOpen]);

  // Update existing effect to only set form data when modal opens for editing
  useEffect(() => {
    if (isOpen && isEdit && rowData) {
      setSelectedTypes({
        banner: rowData?.type?.includes("banner"),
        specialSection: rowData?.type?.includes("special_section"),
      });
      setFormData({
        title: rowData?.title || "",
        text: rowData?.text || "",
        bannerText: rowData?.bannerText || "",
        displayFrom: rowData?.displayFrom ? moment(rowData.displayFrom).format("YYYY-MM-DD") : "",
        displayUntil: rowData?.displayUntil ? moment(rowData.displayUntil).format("YYYY-MM-DD") : "",
        textColor: rowData?.textColor || "#000000",
        backgroundColor: rowData?.backgroundColor || "#ffffff",
        file: rowData?.file,
        isPublished: rowData?.isPublished || false,
      });
    }
  }, [isOpen, isEdit, rowData]);

  const handleTypeChange = (e) => {
    const { name, checked } = e.target;
    setSelectedTypes((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value, // Handle file input for image
    }));
  };



  // A problem the owner can fix, or null.
  const checkForm = () => {
    if (!selectedTypes.banner && !selectedTypes.specialSection) return "Choose Banner, Special Section or both.";
    if (!formData.title?.trim()) return "Please enter a title.";
    if (selectedTypes.banner && !formData.bannerText?.trim()) return "Please enter the banner text.";
    if (selectedTypes.specialSection && !formData.text?.trim()) return "Please enter the text for the special section.";
    if (selectedTypes.specialSection && !formData.file) return "Please add a picture for the special section.";
    if (!formData.displayFrom || !formData.displayUntil) return 'Please choose "Display From" and "Display Until" dates.';
    // The same day is fine: the announcement then shows for that whole day.
    if (moment(formData.displayUntil).isBefore(moment(formData.displayFrom), "day")) {
      return '"Display Until" can\'t be before "Display From".';
    }
    return null;
  };

  const save = async (publish) => {
    setErrorMessage("");
    const problem = checkForm();
    if (problem) {
      setErrorMessage(problem);
      toast.error(problem);
      return;
    }
    setSaving(publish ? "publish" : "draft");
    try {
      // A newly chosen picture is uploaded first; an existing one is kept as is.
      let file = formData.file;
      if (selectedTypes.specialSection && file instanceof File) {
        const uploaded = (await createFile(file).unwrap())?.data;
        file = { name: uploaded?.fileName, url: uploaded?.fileUrl };
      }

      const finalData = {
        type: [...(selectedTypes.banner ? ["banner"] : []), ...(selectedTypes.specialSection ? ["special_section"] : [])],
        title: formData.title.trim(),
        displayFrom: formData.displayFrom,
        displayUntil: formData.displayUntil,
        textColor: formData.textColor,
        backgroundColor: formData.backgroundColor,
        isPublished: publish,
        // Publishing and the dates decide when it shows; there is no separate on/off.
        isActive: true,
        ...(selectedTypes.banner && { bannerText: formData.bannerText.trim() }),
        ...(selectedTypes.specialSection && { text: formData.text.trim(), file }),
        ...(isEdit && rowData?._id && { id: rowData._id }),
      };

      if (isEdit) await updateannouncement(finalData).unwrap();
      else await createAnnouncement(finalData).unwrap();
      toast.success(publish ? "Announcement published" : "Saved as a draft. It isn't shown anywhere until you publish it.");
      closeModal();
    } catch (err) {
      const message = err?.data?.message || "Couldn't save the announcement. Please try again.";
      setErrorMessage(message);
      toast.error(message);
    } finally {
      setSaving(null);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    save(true);
  };

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 overflow-y-auto bg-black bg-opacity-70 flex items-center justify-center z-50 p-4 sm:p-0">
          <div className="rounded-lg shadow-xl w-full max-w-3xl mx-auto h-full sm:h-auto sm:max-h-[90vh] flex flex-col">
            <div className="mx-auto w-full bg-white rounded-lg shadow-lg p-4 sm:px-6 sm:py-4">
              <h1 className="text-2xl font-semibold text-gray-900 mb-6">
                {isEdit ? "Update Announcement" : "Create Announcement"}
              </h1>

                <form onSubmit={handleSubmit} className="space-y-6">
                  <div className="flex space-x-6">
                    <label className="flex items-center space-x-2 cursor-pointer">
                      <input
                        type="checkbox"
                        name="banner"
                        checked={selectedTypes.banner}
                        onChange={handleTypeChange}
                      />
                      <span className="text-sm text-gray-700">Banner</span>
                    </label>
                    <label className="flex items-center space-x-2 cursor-pointer">
                      <input
                        type="checkbox"
                        name="specialSection"
                        checked={selectedTypes.specialSection}
                        onChange={handleTypeChange}
                      />
                      <span className="text-sm text-gray-700">
                        Special Section
                      </span>
                    </label>
                  </div>

                  {selectedTypes.banner && !selectedTypes.specialSection && (
                    <AnnouncementBannersFields
                      formData={formData}
                      handleChange={handleChange}
                    />
                  )}

                  {selectedTypes.specialSection && !selectedTypes.banner && (
                    <AnnouncementSpecialSectionFields
                      formData={formData}
                      handleChange={handleChange}
                    />
                  )}

                  {selectedTypes.banner && selectedTypes.specialSection && (
                    <AnnouncementBothFields
                      formData={formData}
                      handleChange={handleChange}
                    />
                  )}

                  {errorMessage && (
                    <p role="alert" className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">{errorMessage}</p>
                  )}

                  <div className="flex justify-center sm:justify-end items-center flex-wrap space-x-3 py-2">
                    <button
                      type="button"
                      onClick={closeModal}
                      className="px-4 py-2 rounded-lg font-semibold text-sm transition-colors duration-200 ease-in-out text-gray-800 border border-gray-700 hover:bg-gray-100"
                      disabled={Boolean(saving)}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={() => save(false)}
                      disabled={Boolean(saving)}
                      className="inline-flex items-center gap-2 px-4 py-2 rounded-md font-semibold text-sm border border-gray-300 bg-white text-gray-800 hover:bg-gray-50 disabled:opacity-60 disabled:cursor-not-allowed"
                    >
                      {saving === "draft" && <span className="h-4 w-4 animate-spin rounded-full border-2 border-gray-400 border-t-transparent" />}
                      {saving === "draft" ? "Saving…" : "Save draft"}
                    </button>
                    <Button
                      text={saving === "publish" ? "Publishing…" : isEdit && rowData?.isPublished && rowData?.isActive !== false ? "Save and keep published" : "Save and publish"}
                      type="submit"
                      loading={saving === "publish"}
                      disabled={Boolean(saving)}
                    />
                  </div>
                </form>
          
            </div>
          </div>
        </div>
      )}
    </>
  );
}